// extracted by mini-css-extract-plugin
export default {"place-list":"PlaceList_place-list__U7cBt"};